module.exports = __webpack_public_path__ + "img/aset jurusan wa 6.764c50a4.png";